exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".linea-de-tiempo .google-visualization-tooltip {\n  width: 190px !important;\n}\n.linea-de-tiempo .linea {\n  display: -webkit-box;\n  overflow: scroll;\n}\n.linea-de-tiempo .separador {\n  width: 2rem;\n  text-align: center;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Github/trosten/trosten-web-app/src/app/shared/components/linea-tiempo-viajes/linea-de-tiempo.styl
// module id = ../../../../../src/app/shared/components/linea-tiempo-viajes/linea-de-tiempo.styl
// module chunks = main